import React, { useState } from "react";
import "./contact.css";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("http://localhost:5000/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        alert("Failed to send message.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Server error. Please try again later.");
    }
  };

  return (
    <section className="contact-page">
      <h2>Contact Us</h2>
      <p className="contact-subtitle">
        We’d love to hear from you! Reach out for inquiries, collaborations, or support.
      </p>

      <div className="contact-container">
        {/* Contact Info */}
        <div className="contact-information">
          <h3>Our Office</h3>
          <p>Email: <a href="mailto:info@pelicaninfotech.com">info@pelicaninfotech.com</a><br></br>
          <a href="mailto:sales@pelicaninfotech.com"> sales@pelicaninfotech.com</a></p>
           
          <p>Phone: <a href="tel:+919663384126">+91 96633 84126</a></p>
          <p>Location: No 351, 1st Floor, Bannerghatta Rd, opposite to PAI International,
            Sundar Ram Shetty Nagar, Bilekahalli, Bengaluru, Karnataka 560076</p>
        </div>

        {/* Contact Form */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <h3>Send a Message</h3>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Submit</button>
        </form>
      </div>

      {/* Embedded Map */}
      <div className="map-container">
        <iframe
          title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.090327278054!2d77.59874527507526!3d12.901913087407051!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15e6dd38e9c5%3A0x3800afd7bb3fd366!2sPelican%20Infotech!5e0!3m2!1sen!2sin!4v1770202538180!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
}